// Moon phase calculations and utilities

export const MOON_PHASES = [
  { name: 'New Moon', emoji: '<', days: 0 },
  { name: 'Waxing Crescent', emoji: '<', days: 3.7 },
  { name: 'First Quarter', emoji: '<', days: 7.4 },
  { name: 'Waxing Gibbous', emoji: '<', days: 11.1 },
  { name: 'Full Moon', emoji: '<', days: 14.8 },
  { name: 'Waning Gibbous', emoji: '<', days: 18.5 },
  { name: 'Last Quarter', emoji: '<', days: 22.1 },
  { name: 'Waning Crescent', emoji: '<', days: 25.8 },
];

const LUNAR_MONTH = 29.53059; // Average lunar month in days

// Calculate current moon phase based on date
export const getCurrentMoonPhase = (date = new Date()) => {
  // Known new moon date for calculation reference
  const knownNewMoon = new Date('2000-01-06T18:14:00Z');

  const daysSinceKnownNewMoon = (date - knownNewMoon) / (1000 * 60 * 60 * 24);
  const currentPhaseInCycle = daysSinceKnownNewMoon % LUNAR_MONTH;

  // Find the closest moon phase
  for (let i = 0; i < MOON_PHASES.length; i++) {
    const currentPhase = MOON_PHASES[i];
    const nextPhase = MOON_PHASES[(i + 1) % MOON_PHASES.length];

    const currentPhaseDays = currentPhase.days;
    const nextPhaseDays = i === MOON_PHASES.length - 1 ? LUNAR_MONTH : nextPhase.days;

    if (currentPhaseInCycle >= currentPhaseDays && currentPhaseInCycle < nextPhaseDays) {
      return currentPhase;
    }
  }

  return MOON_PHASES[0]; // Default to New Moon
};

// Calculate when a specific moon phase will next occur
export const getNextMoonPhaseDate = (phaseName, fromDate = new Date()) => {
  const targetPhase = MOON_PHASES.find(p => p.name === phaseName);
  if (!targetPhase) return null;

  const knownNewMoon = new Date('2000-01-06T18:14:00Z');
  const daysSinceKnownNewMoon = (fromDate - knownNewMoon) / (1000 * 60 * 60 * 24);
  const currentPhaseInCycle = daysSinceKnownNewMoon % LUNAR_MONTH;

  let daysUntilTargetPhase = targetPhase.days - currentPhaseInCycle;

  // If the phase has already passed in this cycle, get it from the next cycle
  if (daysUntilTargetPhase < 0) {
    daysUntilTargetPhase += LUNAR_MONTH;
  }

  const nextPhaseDate = new Date(fromDate);
  nextPhaseDate.setDate(nextPhaseDate.getDate() + Math.ceil(daysUntilTargetPhase));

  return nextPhaseDate;
};

// Check if a letter can be opened based on moon phase
export const canOpenLetter = (sealedMoonPhase, currentDate = new Date()) => {
  const currentPhase = getCurrentMoonPhase(currentDate);
  return currentPhase.name === sealedMoonPhase;
};

// Get time remaining until letter can be opened
export const getTimeUntilOpen = (sealedMoonPhase, currentDate = new Date()) => {
  const nextPhaseDate = getNextMoonPhaseDate(sealedMoonPhase, currentDate);
  if (!nextPhaseDate) return null;

  const msUntilOpen = nextPhaseDate - currentDate;
  const daysUntilOpen = Math.ceil(msUntilOpen / (1000 * 60 * 60 * 24));

  return {
    date: nextPhaseDate,
    days: daysUntilOpen,
    phase: sealedMoonPhase,
  };
};
